import styled from 'styled-components'

 const StyledIntegracoes = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    position: relative;
    max-height: calc(100% - 92px);

    .integracoes-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 100px;
        background-color: var(--color-neutral-background);
        flex-wrap: wrap;
        gap: 12px;
        padding: 8px 0;
    }

    .integracoes-header-actions {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
        padding-right: 16px;
    }

    .integracoes-search {
        min-width: 220px;
    }

    .integracoes-sort {
        min-width: 200px;
    }

    .integracoes-toggle {
        display: flex;
        align-items: center;
        white-space: nowrap;
    }

    .integracoes-empty {
        width: 100%;
        text-align: center;
        padding: 48px;
        color: #9aa4ad;
        font-size: 14px;
    }
`

export default StyledIntegracoes
